var SUPPORTED_CONSOLE_METHODS = ["log", "debug", "info", "warn", "error"];
function consoleBreadcrumbsPlugin(options) {
    var CONSOLE_LOG_METHODS = SUPPORTED_CONSOLE_METHODS.filter(function (method) {
        return typeof console !== "undefined" &&
            typeof console[method] === "function";
    });
    return function () {
        var self = this;
        CONSOLE_LOG_METHODS.forEach(function (method) {
            var prevHandler = console[method];
            function _console() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var breadcrumb = {
                    action: args.length > 1
                        ? "Console logged some values"
                        : "Console logged a value",
                    category: "console.".concat(method),
                    metadata: {}
                };
                args.forEach(function (arg, i) {
                    return (breadcrumb.metadata["argument".concat(i)] =
                        serializeValue(arg, method));
                });
                self.addBreadcrumb(breadcrumb);
                prevHandler.apply(console, args);
            }
            ;
            console[method] = _console;
        });
    };
}
function serializeValue(value, method) {
    switch (typeof value) {
        case "string":
            return value;
        case "undefined":
            return "undefined";
        default:
            try {
                return JSON.stringify(value, circularReplacer());
            }
            catch (e) {
                if (e && typeof e.message === "string") {
                    return "[could not stringify value: ".concat(e.message, "]");
                }
                return "[could not stringify value]";
            }
    }
}
function circularReplacer() {
    var seenValue = [];
    var seenKey = [];
    return function (key, value) {
        if (typeof value === "object" && value !== null) {
            var i = seenValue.indexOf(value);
            if (i !== -1) {
                return "[cyclic value: ".concat(seenKey[i] || "root object", "]");
            }
            else {
                seenValue.push(value);
                seenKey.push(key);
            }
        }
        return value;
    };
}
export var plugin = consoleBreadcrumbsPlugin;
//# sourceMappingURL=index.js.map